import { render, staticRenderFns } from "./AnalyzeHealthIndex.vue?vue&type=template&id=793b8319&scoped=true"
import script from "./AnalyzeHealthIndex.vue?vue&type=script&lang=js"
export * from "./AnalyzeHealthIndex.vue?vue&type=script&lang=js"
import style0 from "./AnalyzeHealthIndex.vue?vue&type=style&index=0&id=793b8319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b8319",
  null
  
)

export default component.exports